export const chartWrapper = {
  backgroundColor: 'white',
  padding: '10px',
  margin: '0 12px 16px',
  borderRadius: 10,
  border: '1px solid #d9e7fa',
};

export const cardBox = {
  width: '170px',
  margin: 4,
  borderRadius: 8,
  border: '1px solid #d9e7fa',
  padding: '10px',
  display: 'flex',
  alignItems: 'flex-start',
};

export const iconWrap = {
  backgroundColor: 'transparent',
  borderRadius: 8,
  padding: 2,
};

export const labelText = { margin: 0, color: '#475569', fontSize: '0.9rem' };
export const valueText = {
  margin: 0,
  fontWeight: 'bold',
  color: '#0f172a',
};

export const iconBlue = {
  color: 'white',
  backgroundColor: '#ff2b2bff',
  padding: 6,
  borderRadius: 6,
};

export const iconPurple = {
  color: 'white',
  backgroundColor: '#002fffff',
  padding: 6,
  borderRadius: 6,
};

export const iconGreen = {
  color: 'white',
  backgroundColor: '#bcb600ff',
  padding: 6,
  borderRadius: 6,
};

export const tooltipStyles = {
  backgroundColor: 'white',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
};

export const btnShared = {
  padding: '6px 12px',
  backgroundColor: 'transparent',
  borderRadius: '6px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
};

export const btnBorderBlue = {
  ...btnShared,
  border: '1px solid #3b82f6',
  color: '#3b82f6',
};

export const btnBorderGreen = {
  ...btnShared,
  border: '1px solid #10b981',
  color: '#10b981',
};
